/** Bucket validation issues by exact path and by severity. */
export default function groupRulebookIssues(issues) {
    const grouped = { byPath: {}, errors: [], warnings: [] };
    issues.forEach((issue) => {
        const bucket = grouped.byPath[issue.path] ?? [];
        bucket.push(issue);
        grouped.byPath[issue.path] = bucket;
        if (issue.severity === "error") {
            grouped.errors.push(issue);
        }
        else {
            grouped.warnings.push(issue);
        }
    });
    return grouped;
}
/** Issues on `path` itself or any nested path (`path.foo`, `path[0]`). */
export function issuesUnderPath({ byPath, path }) {
    const found = [];
    Object.entries(byPath).forEach(([issuePath, issues]) => {
        if (issuePath === path || issuePath.startsWith(path + ".") || issuePath.startsWith(path + "[")) {
            found.push(...issues);
        }
    });
    return found;
}
